
import * as angular from 'angular';

import { PersonaTiposdocumentoscolaboradoresService } from './personatiposdocumentoscolaboradores.service';

export const PersonaTiposdocumentoscolaboradoresModule = angular.module('PersonaTiposdocumentoscolaboradoresModule', ['ui.router.state'])
    .service('PersonaTiposdocumentoscolaboradoresService', PersonaTiposdocumentoscolaboradoresService)
    .name;
